<template>
  <a-modal
    title="请选择预览栏目"
    :visible="visible"
    :centered="true"
    :width="width"
    :footer="null"
    @cancel="closeModal"
  >
    <a-table
      :columns="columns"
      :data-source="dataSource"
      :pagination="false"
      rowKey="id"
    >
      <span slot="number" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>

      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="onReview(record)">预览</a>
      </span>
    </a-table>
  </a-modal>
</template>
<script>
import { jsonAction, getAction } from '@/api/manage';
const columns = [
  {
    align: 'center',
    title: '序号',
    dataIndex: 'number',
    width: 150,
    scopedSlots: {
      customRender: 'number',
    },
  },
  {
    align: 'center',
    title: '渠道栏目',
    dataIndex: 'columnName',
    width: 300,
    scopedSlots: {
      customRender: 'columnName',
    },
  },

  {
    align: 'center',
    title: '操作',
    dataIndex: 'action',
    width: 150,
    scopedSlots: {
      customRender: 'action',
    },
  },
];
export default {
  props: {
    width: {
      type: String,
      default: '680px',
    },
    type: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      columns,
      isShow: false,
      dataSource: [],
      visible: false,
      getLinkUrl: process.env.VUE_APP_CMS_CONTENT + '/front/api/preview/info',
    };
  },
  methods: {
    onReview(record) {
      console.log(record);
      let idTemp = '';
      let urlTemp = '';
      switch (this.type) {
        //文章 0， 跑马灯 1， banner 2， 产品 3， 公告 4
        case '0':
          idTemp = record.articleId;
          urlTemp = `?id=${idTemp}&source=artical&previewCode=`;
          break;
        case '4':
          idTemp = record.noticeId;
          urlTemp = `?id=${idTemp}&source=notice&previewCode=`;
          break;
      }

      let param = {
        type: this.type,
      };
      getAction(this.getLinkUrl, param).then((res) => {
        console.log(res);
        if (res.success) {
          if (res.result) {
            window.open(`${res.result.url}${urlTemp}${res.result.previewCode}`);
            this.closeModal();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    closeModal() {
      this.visible = false;
    },
  },
};
</script>
